const bodyStyling = enable => {
    if (enable) {
        // Set padding-right for scrollbar width to avoid any overlaying components "jumping"
        let scrollbarWidth = 0;
        scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
        document.body.style.removeProperty('padding-right');
        document.body.style.removeProperty('overflow');
    }
};

const showOverlay = overlay => {
    bodyStyling(true);
    overlay.style.display = 'block';

    setTimeout(() => {
        overlay.style.opacity = 0.5;
    }, 10);
};

const MdsOverlay = {
    inserted(el, binding, vnode) {
        const overlay = document.createElement('div');
        const additionalClass = binding.value.class ? ` ${binding.value.class}` : '';

        overlay.className = `mds-directive--overlay__v3${additionalClass}`;

        if (binding.value.visible) {
            showOverlay(overlay);
        }

        el.clickOutsideEvent = event => {
            if (binding.value.handler) {
                vnode.context[binding.value.handler](event);
            }
        };
        overlay.addEventListener('click', el.clickOutsideEvent);

        el.appendChild(overlay);
    },
    update(el, binding) {
        if (el.hasChildNodes()) {
            const sibling = el.querySelector('.mds-directive--overlay__v3');
            if (sibling === null) {
                return;
            }

            if (binding.value.visible !== binding.oldValue.visible) {
                const visible = binding.value.visible;

                if (visible) {
                    showOverlay(sibling);
                } else {
                    setTimeout(() => {
                        sibling.style.opacity = 0;
                    }, 10);

                    setTimeout(() => {
                        sibling.style.display = 'none';
                        bodyStyling(false);
                    }, 500);
                }
            }
        }
    },
    unbind(el, binding) {
        if (el.hasChildNodes()) {
            if (binding.value.visible) {
                bodyStyling(false);

                el.removeEventListener('click', el.clickOutsideEvent);
            }
        }
    },
};

export default MdsOverlay;
